(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-mood-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-mood-picker')) {
    customElements.define('sc-mood-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const activate = (tab, focus = false) => {
          tabs.forEach(item => {
            const selected = item === tab;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
            this.querySelector(`#${item.getAttribute('aria-controls')}`).hidden = !selected;
          });
          if (focus) tab.focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(tab));
          tab.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = tabs.length - 1;
            if (target !== undefined) { event.preventDefault(); activate(tabs[target], true); }
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
